import { type ReactElement, type ReactNode } from 'react'
import { Accordion } from '@mantine/core'
import { type PreferenceGroup } from '@front/model'

type Props = {
  categories: readonly PreferenceGroup[]
  openGroup: PreferenceGroup | null
  onChange: (category: string | null) => void
  children: ReactNode
}

export const PreferenceCategoryAccordion = ({ categories, openGroup, onChange, children }: Props): ReactElement => {
  return (
    <Accordion value={openGroup} onChange={onChange}>
      {categories.map((category) => (
        <Accordion.Item key={category} value={category}>
          <Accordion.Control>{category}</Accordion.Control>
          <Accordion.Panel>{openGroup === category && children}</Accordion.Panel>
        </Accordion.Item>
      ))}
    </Accordion>
  )
}
